import { atom } from 'nanostores'
import { InterfaceColor } from 'fuse_common/src/api/core'

/**
 * Store is used to reactively override premises color
 * when it changed on client side
 */
export const premisesColorStore = atom<{ [premisesFid: string]: InterfaceColor }>({})

/**
 * For global banner, contains resolved color
 */
export const currentPremisesColorStore = atom<string | null>(null)
